import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Switch, Label, PersonAvatar, InputTextarea } from '@teo/components';
import { format } from 'date-fns';
import { useGet } from '@/query/fetchHooks';

export const SharingSettings = ({
  learningpath,
  setGlobalState,
  globalState,
  authUser,
}: any) => {
  const { t } = useTranslation();
  const [isProtected, setIsProtected] = useState(
    globalState?.lpAccess === 'protected'
  );
  const [versionComment, setVersionComment] = useState(
    globalState?.versionComment ? globalState?.versionComment : ''
  );

  const versions: any = useGet(`/mylps`, {
    organisationId: authUser?.activeOrganisationId,
    userId: authUser?.id,
    lpIsRoot: true,
    masterId: learningpath?.id,
    sort: '-createdAt,-id',
  });

  const handleProtected = () => {
    const newProtected = !isProtected;
    let pubAccess: any;
    if (newProtected) {
      pubAccess = 'protected';
    }
    if (!newProtected) {
      pubAccess = 'private';
    }
    setGlobalState((prev: any) => ({
      ...prev,
      lpAccess: pubAccess,
    }));
  };

  useEffect(() => {
    setGlobalState((prev: any) => ({
      ...prev,
      versionComment: versionComment,
    }));
  }, [versionComment]);

  return (
    <div className="flex flex-col">
      <div className="mb-6">
        <h3 className="mb-2 text-base">
          {t('pages.learning_path.publish.sharing_settings_heading')}
        </h3>
        <p className='"pt-3 text-sm text-grey-07'>
          {t('pages.learning_path.publish.sharing_settings_text')}
        </p>
      </div>
      <div className="flex flex-col gap-4 rounded-lg border border-grey-02 p-4">
        <div className="flex flex-row items-center gap-4">
          <Switch
            checked={isProtected}
            onChange={() => {
              setIsProtected(!isProtected);
              handleProtected();
            }}
          />
          <div>
            <h4 className="pb-2 font-normal">
              {t('pages.learning_path.publish.make_available')}
              {authUser?.organisationName}
            </h4>
            <p className="text-xs text-grey-05">
              {t('pages.learning_path.publish.make_available_description')}
            </p>
          </div>
        </div>
      </div>
      <div className="mt-8 flex flex-col border-t border-grey-02 pt-8">
        <div>
          <h3 className="mb-2 text-base">
            {t('pages.learning_path.publish.add_version_heading')}
          </h3>
          <p className='"pt-3 text-sm text-grey-07'>
            {t('pages.learning_path.publish.add_version_text')}
          </p>
        </div>

        <div className="mt-7 flex flex-col gap-4 rounded-lg border border-grey-02 p-4">
          <div className="mb-2 flex flex-wrap items-center gap-2">
            <PersonAvatar
              inline
              id={authUser?.id}
              name={authUser?.username ? authUser?.username : ''}
              imageSrc={authUser?.picture ? authUser?.picture : ''}
            ></PersonAvatar>

            <div className="mr-4 flex flex-col">
              <span className="text-sm font-medium text-[#231f20]">
                {authUser?.username}
              </span>
            </div>
            <div className="flex flex-col">
              <span className="text-base text-grey-06">
                {format(new Date(), 'dd/MM/yyyy HH:mm ')}
              </span>
            </div>
          </div>

          <div>
            <Label htmlFor="versionComment">
              <p className="text-sm font-semibold">
                {t('pages.publish_course.steps_3.add_comment')}
                <span className="font-normal text-grey-05">
                  {' '}
                  ({t('pages.publish_course.steps_3.optional')})
                </span>
              </p>
            </Label>

            <InputTextarea
              id="versionComment"
              placeholder={t('pages.publish_course.steps_3.add_placeholder')}
              onChange={(event) => setVersionComment(event.currentTarget.value)}
              limit={300}
              value={versionComment}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
